// sections-1.jsx — extraído de index.html el 2026-08-28 (Etapa 1, Bloque C).
//
// Hasta hoy este código vivía incrustado en index.html dentro de un
// <script type="text/babel"> que @babel/standalone compilaba en el navegador de
// cada visitante. El atributo data-source lo atribuía a «NUEVA WEB/sections-1.jsx»,
// una carpeta que no existe en el repositorio ni en el disco: el bloque incrustado
// era la única fuente de verdad (hallazgo H5 del inventario).
//
// El contenido es copia EXACTA del bloque original. No se reformateó ni se
// renombró nada: se compila con las mismas opciones que aplicaba el CDN y la
// salida debe ser byte a byte la misma. Ver scripts/build-jsx.mjs.
//
// Se carga como script clásico, NO como módulo: las declaraciones de nivel
// superior son globales y las otras entradas del home las leen por nombre.

/* global React */
(() => {

const I18N = {
  en: {
    meta: {
      title: "CRMaps — A More Visual Way to Discover Costa Rica",
    },
    nav: {
      home: "Home",
      about: "About",
      maps: "Maps",
      directory: "Directory",
      app: "App",
      community: "Community",
      forBusiness: "For business",
      listBusiness: "List your business",
      tideChart: "Tide chart",
      tideWeather: "Tide Chart & Weather",
      gastronomy: "Gastronomy",
      history: "History",
      geography: "Geography",
      moneyGuide: "Money Guide",
      placesToVisit: "Places to visit",
      costaRicaGuide: "Costa Rica Guide",
    },
    hero: {
      kicker: "Costa Rica · Tourism Platform",
      titleTop: "Costa Rica",
      titleEm: "Mapped differently.",
      lede: "A more visual way to discover Costa Rica. CRMaps brings together interactive regional maps, iOS & Android apps, printed maps, giant public maps and an active social media community — all designed to connect travelers, destinations and local businesses before and during their trip.",
      cta: "Explore the Maps",
      ctaMobile: "Explore the Maps and Directory on the Web App",
      hotspots: "Hotspots",
      regions: "Regions",
      categories: "Categories",
    },
    what: {
      kicker: "The platform",
      titlePrefix: "From printed maps",
      titleEm: "to connected",
      titleSuffix: "travel.",
      lede: "For over a decade, CRMaps has drawn Costa Rica by hand. Today those illustrations are part of a tourism platform with printed guides, mobile apps, interactive maps, giant public maps and social media presence to connect travelers with local businesses across the country.",
      cards: [
        {
          title: "Illustrated drawings, not just a pin.",
          desc: "Every region is illustrated by hand — the cartography from CRMaps printed maps, now brought to life as an interactive experience.",
        },
        {
          title: "Hotspots, not just Pins",
          desc: "Each pin on the map represents a point of interest or verified business, with photos, information, contact, WhatsApp, Google Maps and Waze — one tap away.",
        },
        {
          title: "Web, Mobile, App — one system",
          desc: "Same icons, same legend, same map across every format. The system is understood without confusion.",
        },
        {
          title: "A platform built around discovery",
          desc: "Trusted local businesses in Costa Rica.",
        },
      ],
      stats: {
        years: "Mapping CR",
        reach: "Monthly social media reach",
        requests: "Monthly Web/App requests",
        maps: "Regional Maps",
      },
    },
    regions: {
      kicker: "Maps",
      titlePrefix: "Explore Costa Rica.",
      titleEm: "Map by Map.",
      lede: "Costa Rica is not one map — it's seven tourism regions, each with its own identity, its points of interest and its local dynamic. Download the app or use the web app to explore them.",
      slothyHint: "And don't forget to find Slothy on the Maps!",
      selectLabel: "Select a Region Map",
      allCategories: "All Categories",
      escHint: "Press Esc to close",
      mapChoices: [
        { code: "CR", title: "Costa Rica", subtitle: "From jungles to coastlines" },
        { code: "PJ", title: "Jacó Beach", subtitle: "Central Pacific Surf Hub" },
        { code: "TA", title: "Tamarindo", subtitle: "North Pacific Surf & Lifestyle" },
        { code: "FA", title: "Arenal & La Fortuna", subtitle: "Northern Adventure Region" },
        { code: "MA", title: "Manuel Antonio & Quepos", subtitle: "Southern Pacific Jungle Coast" },
        { code: "CH", title: "Playas del Coco & Hermosa", subtitle: "Northern Gold Coast" },
        { code: "DU", title: "Costa Ballena", subtitle: "Waterfalls & Rainforest Coast" },
        { code: "HE", title: "Herradura Beach", subtitle: "Sportfishing, Marina Coast & Adventures" },
      ],
    },
    directory: {
      kicker: "Directory",
      titleLine1: "Find your next spot!",
      titleLine2: "",
      lede: "Each point of interest belongs to a category, with its own color and icon, for quick orientation.",
      allMaps: "All Maps",
      allCats: "All Categories",
      btnMaps: "Maps",
      btnCats: "Categories",
      searchPlaceholder: "Search places…",
      places: "places",
      loading: "Loading directory…",
      noResults: "No places found.",
      emptyHint: "Select a place to see details",
      catLabels: {
        all: "All", accom: "Stay", rest: "Eat", tour: "Tours", shop: "Shop",
        "poi-beach": "Beach", "poi-park": "Parks", "poi-monument": "Monument",
        "poi-museum": "Museum", "poi-hospital": "Hospital", "poi-police": "Police",
        "poi-atm": "ATM", "poi-info": "Info", "poi-church": "Church",
        default: "Place",
      },
      mapLocation: "Map Location",
      actions: { call: "Call", whatsapp: "WhatsApp", website: "Website", maps: "Google Map", waze: "Waze", email: "Email" },
      place: { title: "Discover this place", subtitle: "More information, services, location, photos & more" },
    },
    categories: {
      labels: {
        accommodation: "Stay", restaurant: "Eat", transport: "Transport",
        shopping: "Shop", general: "General", beach: "Beach", park: "Park",
        atm: "ATM", info: "Info", hospital: "Hospital", police: "Police",
        museum: "Museum", monument: "Monument", church: "Church", promo: "Promo",
      },
    },
    mobile: {
      kicker: "The Mobile App",
      titlePrefix: "Costa Rica,",
      titleEm: "in your pocket.",
      lede: "Free on iOS and Android. No login required — download the app and start exploring every region of Costa Rica. The CRMaps app mirrors the web viewer with native gestures and category filters, large buttons, clear text and simple navigation.",
      modeMobile: "Mobile",
      modeWeb: "Web",
      features: [

        { strong: "Category Filter", text: "show only beaches, only restaurants, or layer them all." },
        { strong: "One-tap actions", text: "Google Maps, Waze, call, WhatsApp, navigate — from any Pin." },
        { strong: "Pin Popups", text: "Quick facts and directions, photo gallery." },
      ],
      appStorePrefix: "Download on the",
      appStore: "App Store",
      googlePrefix: "Get it on",
      googlePlay: "Google Play",
      qrTitle: "Scan to install",
      qrText: "Point your camera at the code — opens the right store automatically.",
    },
    navigate: {
      waze: "Open in Waze",
      distance: "14 min · 6.2 km",
      google: "Google Maps",
      googleSub: "Turn-by-turn directions",
      kicker: "Get me there",
      titlePrefix: "From Pin",
      titleEm: "to driveway,",
      titleSuffix: "in one tap.",
      lede: "Every CRMaps Hotspot opens directly in Waze or Google Maps with the verified GPS coordinates and pickup point — no copy-pasting addresses, no wrong driveways.",
      features: [
        { title: "Verified GPS Coordinates", desc: "Each Pin's location is hand-confirmed against the real driveway, not the street centroid." },
        { title: "One-tap Navigation", desc: "Open Waze for live traffic, Google Maps for transit, or copy coordinates for any other App." },
        { title: "Live ETA on the Popup", desc: "See estimated drive time before you commit to the trip — no second-guessing." },
      ],
    },
    community: {
      kicker: "Community",
      titlePrefix: "Built with travelers,",
      titleEm: "shared with the world.",
      lede: "CRMaps lives beyond the Map: a community of travelers, businesses and locals sharing the best of Costa Rica every day across Instagram and Facebook.",
      posts: [
        "Manuel Antonio sunrise — Pin #214 just got 5★",
        "New Region live: Puerto Viejo, 128 Hotspots",
        "Calzonuda has been busy mapping Guanacaste",
        "10 years of painted Maps — thank you, Costa Rica",
      ],
      instagram: "Follow on Instagram",
      facebook: "Follow on Facebook",
    },
    contact: {
      kicker: "Get in touch",
      titlePrefix: "Ready to put your business",
      titleEm: "on the Map?",
      lede: "Tell us about your business and the Region you serve — we'll get back within one business day with the right plan.",
      whatsapp: "WhatsApp · +506 4707 3168",
      whatsappSub: "Fastest response, business hours",
      call: "Call · +506 2643 5084",
      callSub: "Mon–Fri · 8am–5pm CST",
      email: "info@crmaps.com",
      emailSub: "Email — replies within 24h",
      success: "✓ Thanks — we'll be in touch within one business day.",
      error: "We couldn't send your inquiry. Please try again or email us directly.",
      sending: "Sending...",
      labels: {
        name: "Your name",
        business: "Business name",
        email: "Email",
        whatsapp: "WhatsApp",
        type: "Business type",
        region: "Region",
        message: "Tell us about your business",
      },
      businessTypes: ["Accommodation", "Restaurant", "Tour operator", "Shop", "Transport", "Other"],
      regions: ["Jaco Beach", "Manuel Antonio & Quepos", "Tamarindo", "Arenal Volcano & La Fortuna", "Herradura", "Playas del Coco & Hermosa", "Costa Ballena", "Other"],
      messagePlaceholder: "What you do, where you are, and what you're hoping CRMaps can help with...",
      disclaimer: "By submitting you agree to be contacted about CRMaps listings. We never share your details.",
      submit: "Send inquiry",
    },
    footer: {
      brand: "A more visual way to discover Costa Rica. Built locally — in San José, Costa Rica.",
      explore: "Explore",
      business: "Business",
      company: "Company",
      regionalMaps: "Regional Maps",
      categories: "Categories",
      mobileApp: "Mobile App",
      tideChart: "Tide chart",
      listPin: "For Business",
      sponsorRegion: "Sponsor a Region",
      talkSales: "Talk to sales",
      about: "About CRMaps",
      community: "Community",
      contact: "Contact",
      privacy: "Privacy",
      admin: "Admin",
      aboutModalTitle: "About CRMaps",
      aboutModalText: [
        "CRMaps is a Costa Rica tourism platform built around illustrated Regional Maps, local discovery and connected travel experiences. What started as a printed Map project evolved into a multi-platform ecosystem including Interactive Maps, Mobile Apps, tourism information and local business discovery tools designed to help travelers explore Costa Rica more visually and intuitively.",
        "We are committed to helping travelers discover authentic destinations while supporting local businesses, tourism communities and regional experiences throughout Costa Rica. Our goal is to make travel discovery more visual, more connected and more inspiring for every visitor exploring the country.",
      ],
      privacyModalTitle: "Privacy Policy",
      privacyUpdated: "Last updated: May 2026",
      privacyModalText: [
        "Your privacy is important to us. It is CRMaps's policy to respect your privacy regarding any information we may collect from you across our website, http://www.crmaps.com, and other sites we own and operate. We only ask for personal information when we truly need it to provide a service to you.",
        "We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used. We only retain collected information for as long as necessary to provide you with your requested service.",
        "What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification. We don’t share any personally identifying information publicly or with third-parties, except when required to by law.",
        "Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.",
        "You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services. Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information.",
        "If you have any questions about how we handle user data and personal information, feel free to contact us. This policy is effective as of May 2026.",
      ],
      close: "Close",
      bottom: "© 2026 CRMaps · Made in Costa Rica · Pura vida",
      mascot: "Mascots: Calzonuda the red-eyed tree frog · Slothy the sloth",
    },
  },
  es: {
    meta: {
      title: "CRMaps — Una Forma Más Visual de Descubrir Costa Rica",
    },
    nav: {
      home: "Inicio",
      about: "Acerca de",
      maps: "Mapas",
      directory: "Directorio",
      app: "App",
      community: "Comunidad",
      forBusiness: "Para negocios",
      listBusiness: "Anunciá tu negocio",
      tideChart: "Mareas",
      tideWeather: "Mareas y clima",
      gastronomy: "Gastronomía",
      history: "Historia",
      geography: "Geografía",
      moneyGuide: "Guía de Dinero",
      placesToVisit: "Lugares para visitar",
      costaRicaGuide: "Guía de Costa Rica",
    },
    hero: {
      kicker: "Costa Rica · Plataforma turística",
      titleTop: "Costa Rica",
      titleEm: "Mapeada diferente.",
      lede: "Una forma visual de descubrir Costa Rica. CRMaps reúne Mapas regionales interactivos, Apps para iOS y Android, Mapas impresos, Mapas públicos de gran formato y una comunidad activa en Redes Sociales. Todo pensado para conectar viajeros, destinos y negocios locales antes y durante su viaje.",
      cta: "Explorar los Mapas",
      ctaMobile: "Explorar los Mapas y el Directorio en la Web App",
      hotspots: "Puntos de Interés",
      regions: "Regiones",
      categories: "Categorías",
    },
    what: {
      kicker: "La plataforma",
      titlePrefix: "De Mapas Impresos",
      titleEm: "a Viajes",
      titleSuffix: "Conectados.",
      lede: "Durante más de una década, CRMaps ha dibujado Costa Rica a mano. Hoy esas ilustraciones forman parte de una plataforma turística con guías impresas, apps móviles, mapas interactivos, mapas públicos de gran formato y presencia en redes sociales para conectar viajeros con negocios locales en todo el país.",
      cards: [
        {
          title: "Dibujos Ilustrativos, no solo un Pin.",
          desc: "Cada región está ilustrada a mano: la cartografía de los Mapas impresos de CRMaps, ahora llevada a una Experiencia Interactiva.",
        },
        {
          title: "Hotspots, no solo Pines",
          desc: "Cada Pin en Mapa representa un punto de interés o negocio verificado, con fotos, información, contacto, WhatsApp, Google Maps y Waze a un toque.",
        },
        {
          title: "Web, Móvil y App en un solo sistema",
          desc: "Los mismos íconos, la misma leyenda y el mismo Mapa en cada formato. Se entiende el sistema sin confusiones.",
        },
        {
          title: "Una plataforma pensada para descubrir",
          desc: "Negocios locales confiables en Costa Rica.",
        },
      ],
      stats: {
        years: "Mapeando CR",
        reach: "Alcance mensual en redes",
        requests: "Solicitudes mensuales Web/App",
        maps: "Mapas Regionales",
      },
    },
    regions: {
      kicker: "Mapas",
      titlePrefix: "Explorá Costa Rica.",
      titleEm: "Mapa por Mapa.",
      lede: "Costa Rica no es un solo Mapa: son siete regiones turísticas, cada una con su propia identidad, sus puntos de interés y su dinámica local. Descargá la app o usá la web app para explorarlas.",
      slothyHint: "Y no te olvides de encontrar a Slothy en los Mapas!",
      selectLabel: "Seleccionar Mapa de Región",
      allCategories: "Todas las Categorías",
      escHint: "Presioná Esc para cerrar",
      mapChoices: [
        { code: "CR", title: "Costa Rica", subtitle: "De la selva a la costa" },
        { code: "PJ", title: "Jacó Beach", subtitle: "Surf en el Pacífico Central" },
        { code: "TA", title: "Tamarindo", subtitle: "Surf y estilo de vida en el Pacífico Norte" },
        { code: "FA", title: "Arenal & La Fortuna", subtitle: "Región de aventura del norte" },
        { code: "MA", title: "Manuel Antonio & Quepos", subtitle: "Costa selvática del Pacífico Sur" },
        { code: "CH", title: "Playas del Coco & Hermosa", subtitle: "Costa Dorada del norte" },
        { code: "DU", title: "Costa Ballena", subtitle: "Cataratas y costa de bosque lluvioso" },
        { code: "HE", title: "Herradura Beach", subtitle: "Pesca deportiva, marina, costa y aventuras" },
      ],
    },
    directory: {
      kicker: "Directorio",
      titleLine1: "Explorá tu próxima parada!",
      titleLine2: "",
      lede: "Cada punto de interés pertenece a una categoría, con color e ícono propios, para orientarse rápido.",
      allMaps: "Todos los Mapas",
      allCats: "Todas las Categorías",
      btnMaps: "Mapas",
      btnCats: "Categorías",
      searchPlaceholder: "Buscar lugares…",
      places: "lugares",
      loading: "Cargando directorio…",
      noResults: "No se encontraron lugares.",
      emptyHint: "Seleccioná un lugar para ver los detalles",
      catLabels: {
        all: "Todo", accom: "Hospedaje", rest: "Comer", tour: "Tours", shop: "Compras",
        "poi-beach": "Playa", "poi-park": "Parques", "poi-monument": "Monumento",
        "poi-museum": "Museo", "poi-hospital": "Hospital", "poi-police": "Policía",
        "poi-atm": "ATM", "poi-info": "Info", "poi-church": "Iglesia",
        default: "Lugar",
      },
      mapLocation: "Ubicación",
      actions: { call: "Llamar", whatsapp: "WhatsApp", website: "Sitio web", maps: "Google Map", waze: "Waze", email: "Email" },
      place: { title: "Descubre este lugar", subtitle: "Más información, servicios, ubicación, fotos y más" },
    },
    categories: {
      labels: {
        accommodation: "Hospedaje", restaurant: "Comer", transport: "Transporte",
        shopping: "Compras", general: "General", beach: "Playa", park: "Parque",
        atm: "ATM", info: "Info", hospital: "Hospital", police: "Policía",
        museum: "Museo", monument: "Monumento", church: "Iglesia", promo: "Promo",
      },
    },
    mobile: {
      kicker: "La App móvil",
      titlePrefix: "Costa Rica,",
      titleEm: "en tu bolsillo.",
      lede: "Gratis en iOS y Android. No necesitás iniciar sesión: descargás la app y empezás a explorar cada región de Costa Rica. La app de CRMaps replica el visor web con gestos nativos, filtros por categoría, botones grandes, texto claro y una navegación simple.",
      modeMobile: "Móvil",
      modeWeb: "Web",
      features: [

        { strong: "Filtro por Categoría", text: "mostrá solo playas, solo restaurantes o todas las capas juntas." },
        { strong: "Acciones a un toque", text: "Google Maps, Waze, llamada, WhatsApp y navegación desde cualquier Pin." },
        { strong: "Popups de Pines", text: "Datos rápidos, direcciones y galería de fotos." },
      ],
      appStorePrefix: "Descargar en",
      appStore: "App Store",
      googlePrefix: "Disponible en",
      googlePlay: "Google Play",
      qrTitle: "Escaneá para instalar",
      qrText: "Apuntá la cámara al código; abre la tienda correcta automáticamente.",
    },
    navigate: {
      waze: "Abrir en Waze",
      distance: "14 min · 6.2 km",
      google: "Google Maps",
      googleSub: "Indicaciones paso a paso",
      kicker: "Cómo llegar",
      titlePrefix: "Del Pin",
      titleEm: "a la entrada,",
      titleSuffix: "en un toque.",
      lede: "Cada Hotspot de CRMaps abre directamente en Waze o Google Maps con coordenadas GPS verificadas y punto de llegada correcto: sin copiar direcciones, sin entradas equivocadas.",
      features: [
        { title: "Coordenadas GPS Verificadas", desc: "La ubicación de cada Pin se confirma contra la entrada real, no contra el centro aproximado de la calle." },
        { title: "Navegación a un toque", desc: "Abrí Waze para tráfico en vivo, Google Maps para rutas o copiá coordenadas para cualquier otra App." },
        { title: "ETA en vivo en el Popup", desc: "Ves el tiempo estimado de manejo antes de decidir el viaje, sin adivinar." },
      ],
    },
    community: {
      kicker: "Comunidad",
      titlePrefix: "Hecho con viajeros,",
      titleEm: "compartido con el mundo.",
      lede: "CRMaps vive más allá del Mapa: una comunidad de viajeros, negocios y locales compartiendo lo mejor de Costa Rica cada día en Instagram y Facebook.",
      posts: [
        "Amanecer en Manuel Antonio: el Pin #214 acaba de recibir 5★",
        "Nueva Región en vivo: Puerto Viejo, 128 Hotspots",
        "Calzonuda ha estado ocupada mapeando Guanacaste",
        "10 años de Mapas ilustrados: gracias, Costa Rica",
      ],
      instagram: "Seguinos en Instagram",
      facebook: "Seguinos en Facebook",
    },
    contact: {
      kicker: "Contacto",
      titlePrefix: "¿Listo para poner tu negocio",
      titleEm: "en el Mapa?",
      lede: "Contanos sobre tu negocio y la Región donde operás. Te respondemos en un día hábil con el plan adecuado.",
      whatsapp: "WhatsApp · +506 4707 3168",
      whatsappSub: "Respuesta más rápida, horario laboral",
      call: "Llamar · +506 2643 5084",
      callSub: "Lun–Vie · 8am–5pm CST",
      email: "info@crmaps.com",
      emailSub: "Email — respondemos en menos de 24h",
      success: "✓ Gracias; te contactaremos en un día hábil.",
      error: "No pudimos enviar tu consulta. Intentá de nuevo o escribinos directamente.",
      sending: "Enviando...",
      labels: {
        name: "Tu nombre",
        business: "Nombre del negocio",
        email: "Email",
        whatsapp: "WhatsApp",
        type: "Tipo de negocio",
        region: "Región",
        message: "Contanos sobre tu negocio",
      },
      businessTypes: ["Hospedaje", "Restaurante", "Tour operador", "Tienda", "Transporte", "Otro"],
      regions: ["Jaco Beach", "Manuel Antonio & Quepos", "Tamarindo", "Arenal Volcano & La Fortuna", "Herradura", "Playas del Coco & Hermosa", "Costa Ballena", "Otra"],
      messagePlaceholder: "Qué hacés, dónde estás y qué esperás que CRMaps pueda ayudar a lograr...",
      disclaimer: "Al enviar aceptás que te contactemos sobre listados de CRMaps. Nunca compartimos tus datos.",
      submit: "Enviar consulta",
    },
    footer: {
      brand: "Una forma más visual de descubrir Costa Rica. Hecho localmente en San José, Costa Rica.",
      explore: "Explorar",
      business: "Negocios",
      company: "Compañía",
      regionalMaps: "Mapas Regionales",
      categories: "Categorías",
      mobileApp: "App Móvil",
      tideChart: "Mareas",
      listPin: "Para negocios",
      sponsorRegion: "Patrocinar una Región",
      talkSales: "Hablar con ventas",
      about: "Acerca de CRMaps",
      community: "Comunidad",
      contact: "Contacto",
      privacy: "Privacidad",
      admin: "Admin",
      aboutModalTitle: "Acerca de CRMaps",
      aboutModalText: [
        "CRMaps es una plataforma turística de Costa Rica construida alrededor de Mapas Regionales ilustrados, descubrimiento local y experiencias de viaje conectadas. Lo que comenzó como un proyecto de Mapas impresos evolucionó hasta convertirse en un ecosistema multiplataforma que incluye Mapas Interactivos, Apps móviles, información turística y herramientas de descubrimiento de negocios locales diseñadas para ayudar a los viajeros a explorar Costa Rica de forma más visual e intuitiva.",
        "Estamos comprometidos con ayudar a los viajeros a descubrir destinos auténticos mientras apoyamos a negocios locales, comunidades turísticas y experiencias regionales en toda Costa Rica. Nuestro objetivo es hacer que el descubrimiento de viajes sea más visual, más conectado y más inspirador para cada visitante que explora el país.",
      ],
      privacyModalTitle: "Política de privacidad",
      privacyUpdated: "Última actualización: mayo de 2026",
      privacyModalText: [
        "Tu privacidad es importante para nosotros. Es política de CRMaps respetar tu privacidad con respecto a cualquier información que podamos recopilar en nuestro sitio web, http://www.crmaps.com, y en otros sitios que poseemos y operamos. Solo solicitamos información personal cuando realmente la necesitamos para brindarte un servicio.",
        "La recopilamos por medios justos y legales, con tu conocimiento y consentimiento. También te informamos por qué la recopilamos y cómo será utilizada. Solo conservamos la información recopilada durante el tiempo necesario para brindarte el servicio solicitado.",
        "Los datos que almacenamos serán protegidos mediante medios comercialmente aceptables para evitar pérdida, robo, acceso no autorizado, divulgación, copia, uso o modificación. No compartimos públicamente información de identificación personal ni con terceros, excepto cuando la ley lo requiera.",
        "Nuestro sitio web puede enlazar a sitios externos que no son operados por nosotros. Tené en cuenta que no tenemos control sobre el contenido ni las prácticas de esos sitios, y no podemos aceptar responsabilidad por sus respectivas políticas de privacidad.",
        "Podés rechazar nuestra solicitud de información personal, entendiendo que quizá no podamos brindarte algunos de los servicios deseados. El uso continuado de nuestro sitio web se considerará aceptación de nuestras prácticas sobre privacidad e información personal.",
        "Si tenés preguntas sobre cómo manejamos los datos de usuarios e información personal, podés contactarnos. Esta política entra en vigencia en mayo de 2026.",
      ],
      close: "Cerrar",
      bottom: "© 2026 CRMaps · Hecho en Costa Rica · Pura vida",
      mascot: "Mascotas: Calzonuda la rana de ojos rojos · Slothy el perezoso",
    },
  },
};

window.CRMAPS_I18N = I18N;

function LanguageToggle({ lang, onChange }) {
  return (
    <div className="lang-toggle" aria-label="Language selector">
      <button type="button" className={lang === "es" ? "is-on" : ""} onClick={() => onChange("es")} aria-pressed={lang === "es"}>ES</button>
      <button type="button" className={lang === "en" ? "is-on" : ""} onClick={() => onChange("en")} aria-pressed={lang === "en"}>EN</button>
    </div>
  );
}

// ============================================================
// FLOAT NAV
// ============================================================
function FloatNav({ activeSection, lang, onLanguageChange, copy }) {
  const [tucked, setTucked] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [menuWidth, setMenuWidth] = React.useState(0);
  const [guideOpen, setGuideOpen] = React.useState(false);
  const guideRef = React.useRef(null);
  const [regionsOpen, setRegionsOpen] = React.useState(false);
  const regionsRef = React.useRef(null);
  React.useEffect(() => {
    const onScroll = () => setTucked(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  React.useEffect(() => {
    if (!guideOpen) return;
    const handler = (e) => {
      if (guideRef.current && !guideRef.current.contains(e.target)) setGuideOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [guideOpen]);
  React.useEffect(() => {
    if (!regionsOpen) return;
    const handler = (e) => {
      if (regionsRef.current && !regionsRef.current.contains(e.target)) setRegionsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [regionsOpen]);
  const items = [
  { id: "what", label: copy.nav.about },
  { id: "regions", label: copy.nav.maps },
  { id: "directory", label: copy.nav.directory },
  { id: "mobile", label: copy.nav.app },
  { id: "community", label: copy.nav.community }];
  // Guide URLs per language (slugs differ per language — not a simple prefix swap).
  const GUIDE_URLS = {
    en: { tide: "/en/tide-chart/", gastronomy: "/en/gastronomy/", history: "/en/history/", geography: "/en/geography/", money: "/en/money-guide/", places: "/en/places-to-visit/" },
    es: { tide: "/es/mareas-y-clima/", gastronomy: "/es/gastronomia/", history: "/es/historia/", geography: "/es/geografia/", money: "/es/guia-de-dinero/", places: "/es/lugares-para-visitar/" }
  };
  const g = GUIDE_URLS[lang] || GUIDE_URLS.en;
  // Region template URLs per language (slugs differ per language — not a simple prefix swap).
  const REGION_LINKS = {
    en: [
      { href: "/en/jaco-beach/", label: "Jacó Beach" },
      { href: "/en/arenal-volcano-la-fortuna/", label: "Arenal Volcano & La Fortuna" },
      { href: "/en/tamarindo/", label: "Tamarindo" },
      { href: "/en/manuel-antonio-quepos/", label: "Manuel Antonio & Quepos" },
      { href: "/en/playas-del-coco/", label: "Playas del Coco & Hermosa" },
      { href: "/en/herradura/", label: "Herradura" },
      { href: "/en/costa-ballena/", label: "Costa Ballena" }
    ],
    es: [
      { href: "/es/playa-jaco/", label: "Playa Jacó" },
      { href: "/es/volcan-arenal-la-fortuna/", label: "Volcán Arenal y La Fortuna" },
      { href: "/es/tamarindo/", label: "Tamarindo" },
      { href: "/es/manuel-antonio-quepos/", label: "Manuel Antonio y Quepos" },
      { href: "/es/playas-del-coco/", label: "Playas del Coco y Hermosa" },
      { href: "/es/herradura/", label: "Herradura" },
      { href: "/es/costa-ballena/", label: "Costa Ballena" }
    ]
  };
  const regionLinks = REGION_LINKS[lang] || REGION_LINKS.en;
  const regionsLabel = lang === "es" ? "Regiones" : "Regions";
  const hamburgerItems = [
  { href: g.tide, label: copy.nav.tideWeather },
  { href: g.gastronomy, label: copy.nav.gastronomy },
  { href: g.history, label: copy.nav.history },
  { href: g.geography, label: copy.nav.geography },
  { href: g.money, label: copy.nav.moneyGuide },
  { href: g.places, label: copy.nav.placesToVisit }];

  React.useEffect(() => {
    const measure = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      ctx.font = "600 13px Roboto";
      const maxLabelWidth = hamburgerItems.concat(regionLinks).reduce((max, item) => {
        const width = ctx.measureText(item.label).width;
        return Math.max(max, width);
      }, 0);
      setMenuWidth(Math.ceil(maxLabelWidth + 44));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [lang]);

  return (
	    <React.Fragment>
	      <div className="site-lang-toggle">
	        <LanguageToggle lang={lang} onChange={onLanguageChange} />
	      </div>
	      <nav className={`float-nav ${tucked ? "is-tucked" : ""}`}>
        <a href="#top" className="float-nav__brand" aria-label="CRMaps home"
          onClick={(e) => { e.preventDefault(); document.getElementById("top")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}>
          <img src="/imagenes/index/logo_menu.png" alt="CRMaps" />
        </a>
        <div className="float-nav__items">
          <div className="float-nav__page-links">
            {items.map((i) =>
            <a key={i.id} href={`#${i.id}`}
              className={activeSection === i.id ? "is-active" : ""}
              onClick={(e) => { e.preventDefault(); document.getElementById(i.id)?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
            >{i.label}</a>
            )}
          </div>
          <div className="cr-guide-wrapper" ref={regionsRef}>
            <button
              type="button"
              className="cr-guide-btn"
              aria-expanded={regionsOpen}
              onClick={() => { setRegionsOpen((v) => !v); setGuideOpen(false); }}
            >
              {regionsLabel}
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
            </button>
            {regionsOpen && (
              <div className="cr-guide-dropdown">
                {regionLinks.map((r) => (
                  <a key={r.href} href={r.href} onClick={() => setRegionsOpen(false)}>{r.label}</a>
                ))}
              </div>
            )}
          </div>
          <div className="cr-guide-wrapper" ref={guideRef}>
            <button
              type="button"
              className="cr-guide-btn"
              aria-expanded={guideOpen}
              onClick={() => { setGuideOpen((v) => !v); setRegionsOpen(false); }}
            >
              {copy.nav.costaRicaGuide}
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
            </button>
            {guideOpen && (
              <div className="cr-guide-dropdown">
                <a href={g.tide} onClick={() => setGuideOpen(false)}>{copy.nav.tideWeather}</a>
                <a href={g.gastronomy} onClick={() => setGuideOpen(false)}>{copy.nav.gastronomy}</a>
                <a href={g.history} onClick={() => setGuideOpen(false)}>{copy.nav.history}</a>
                <a href={g.geography} onClick={() => setGuideOpen(false)}>{copy.nav.geography}</a>
                <a href={g.money} onClick={() => setGuideOpen(false)}>{copy.nav.moneyGuide}</a>
                <a href={g.places} onClick={() => setGuideOpen(false)}>{copy.nav.placesToVisit}</a>
              </div>
            )}
          </div>
          <a href="#contact" className="float-nav__cta"
            onClick={(e) => { e.preventDefault(); document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
          >{copy.nav.listBusiness}</a>
          <div className="float-nav__lang"><LanguageToggle lang={lang} onChange={onLanguageChange} /></div>
        </div>
      </nav>
      <button
        type="button"
        className="hamburger"
        aria-label="Open menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span />
      </button>
      <div
        className={`hamburger-panel ${menuOpen ? "is-open" : ""}`}
        style={menuWidth ? { width: `${menuWidth}px` } : undefined}
      >
        <span style={{ display: "block", padding: "12px 18px 4px", font: "700 10px/1 'Roboto'", letterSpacing: "0.1em", textTransform: "uppercase", color: "#8fa3b4" }}>{regionsLabel}</span>
        {regionLinks.map((r) => (
          <a key={r.href} href={r.href}>{r.label}</a>
        ))}
        <hr style={{ border: 0, borderTop: "1px solid rgba(0,0,0,0.08)", margin: "6px 18px" }} />
        {hamburgerItems.map((i) => (
          <a key={i.href} href={i.href} onClick={i.onClick}>{i.label}</a>
        ))}
      </div>
    </React.Fragment>);

}

// ============================================================
// HERO
// ============================================================
function Hero({ copy, lang }) {
  const [activePin, setActivePin] = React.useState("manuel");

  // auto-cycle the hero pins
  React.useEffect(() => {
    const ids = window.HERO_PINS.map((p) => p.id);
    let i = ids.indexOf(activePin);
    const t = setInterval(() => {
      i = (i + 1) % ids.length;
      setActivePin(ids[i]);
    }, 2400);
    return () => clearInterval(t);
  }, []);

  return (
	    <section className="hero" id="top">
	      <div className="hero__copy">
	        <span className="hero__kicker">{copy.hero.kicker}</span>
	        <h1 className="hero__title">
	          {copy.hero.titleTop}<br />
	          <em>{copy.hero.titleEm}  
	          
	</em>
	        </h1>
	        <p className="hero__lede" style={{ fontFamily: "Roboto", color: "rgb(216, 197, 197)", backgroundColor: "rgba(54, 57, 63, 0)" }}>{copy.hero.lede}


        </p>
        <div className="hero__cta">
	          <a href="#regions" className="btn btn--primary hero__cta-desktop"
	            onClick={(e) => { e.preventDefault(); document.getElementById("regions")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}>
	            {copy.hero.cta}
          
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
          </a>
	          <a href="/Crmaps_web-app/Crmaps_web-app.html" className="btn btn--primary hero__cta-mobile">
	            {copy.hero.ctaMobile}
          
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
          </a>
          
        </div>
	        <div className="hero__meta">
	          <div><strong>640+</strong><span>{copy.hero.hotspots}</span></div>
	          <div><strong>7</strong><span>{copy.hero.regions}</span></div>
	          <div><strong>15</strong><span>{copy.hero.categories}</span></div>
	        </div>
      </div>
      <div className="hero__map-wrap">
        <window.CostaRicaMap activeId={activePin} onSelect={setActivePin} lang={lang} />
      </div>
    </section>);}

// ============================================================
// WHAT IS — narrative + stat strip
// ============================================================
function WhatSection({ copy }) {
  const cardIcons = [
    <path d="M12 19l7-7 3 3-7 7-3-3z M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z M2 2l7.586 7.586 M11 11a2 2 0 100-4 2 2 0 000 4z" strokeWidth="1.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />,
    <path d="M12 2C8 2 5 5 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-4-3-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor" />,
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="14" rx="2" /><path d="M2 10h20" /></g>,
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 17 9 11 13 15 21 7" /><polyline points="14 7 21 7 21 14" /></g>,
  ];

  return (
    <section className="section section--paper" id="what" data-screen-label="02 What is CRMaps">
      <div className="section-inner">
        <div className="what-grid reveal">
          <div>
            <span className="kicker">{copy.what.kicker}</span>
            <h2 className="title">{copy.what.titlePrefix} <em>{copy.what.titleEm}</em> {copy.what.titleSuffix}</h2>
            <p className="lede">
              {copy.what.lede}
            </p>
          </div>
          <div className="what-stack reveal-stagger">
            {copy.what.cards.map((c, i) =>
            <div className="what-card" key={i}>
                <div className="what-card__icon"><svg viewBox="0 0 24 24">{cardIcons[i]}</svg></div>
                <div>
                  <h4>{c.title}</h4>
                  <p>{c.desc}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="what-stat-strip reveal-stagger">
          <div className="what-stat"><strong>15+ Yrs</strong><span>{copy.what.stats.years}</span></div>
          <div className="what-stat"><CountUp end={350000} suffix="+" /><span>{copy.what.stats.reach}</span></div>
          <div className="what-stat"><CountUp end={80000} suffix="+" /><span>{copy.what.stats.requests}</span></div>
          <div className="what-stat"><CountUp end={7} /><span>{copy.what.stats.maps}</span></div>
        </div>
      </div>
    </section>);

}

function CountUp({ end, suffix = "" }) {
  const [v, setV] = React.useState(0);
  const ref = React.useRef(null);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        const dur = 1500;
        const start = performance.now();
        const tick = (t) => {
          const p = Math.min(1, (t - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          setV(Math.round(end * eased));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        io.disconnect();
      }
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [end]);
  return <strong ref={ref}>{v.toLocaleString()}{suffix}</strong>;
}

// ============================================================
// REGIONS — carousel
// ============================================================
const REGIONS = [
{ id: "guanacaste", name: "Guanacaste", coast: "Pacific Northwest", count: 184,
  bg: "radial-gradient(ellipse 40% 50% at 30% 50%, #8fb16e 0%, transparent 60%), radial-gradient(ellipse 30% 40% at 70% 40%, #c8b56a 0%, transparent 60%), linear-gradient(180deg, #b0d6e2 0%, #d8e6c4 60%, #b3c87f 100%)",
  pins: [{ x: 24, y: 46, c: "#e23838" }, { x: 38, y: 62, c: "#16a34a" }, { x: 52, y: 38, c: "#f59e0b" }, { x: 68, y: 54, c: "#38bdf8" }] },
{ id: "tamarindo", name: "Tamarindo & Nicoya", coast: "Pacific Coast", count: 156,
  bg: "radial-gradient(ellipse 50% 50% at 70% 50%, #a0c082 0%, transparent 60%), linear-gradient(180deg, #88c4dd 0%, #c5d68a 80%, #d4c984 100%)",
  pins: [{ x: 32, y: 42, c: "#38bdf8" }, { x: 46, y: 60, c: "#e23838" }, { x: 62, y: 48, c: "#f59e0b" }] },
{ id: "arenal", name: "Arenal & La Fortuna", coast: "Central Volcanic", count: 142,
  bg: "radial-gradient(ellipse 40% 60% at 60% 40%, #5b8c50 0%, transparent 60%), radial-gradient(circle at 60% 40%, #6b4226 0 60px, transparent 61px), linear-gradient(180deg, #c4dceb 0%, #a8c87f 70%)",
  pins: [{ x: 42, y: 38, c: "#16a34a" }, { x: 58, y: 48, c: "#e23838" }, { x: 48, y: 62, c: "#f59e0b" }] },
{ id: "monteverde", name: "Monteverde", coast: "Cloud Forest", count: 98,
  bg: "radial-gradient(ellipse 70% 70% at 50% 60%, #4a7857 0%, transparent 60%), linear-gradient(180deg, #d8e6e0 0%, #93b890 60%, #6a8e58 100%)",
  pins: [{ x: 44, y: 46, c: "#16a34a" }, { x: 54, y: 58, c: "#a855f7" }] },
{ id: "manuel", name: "Manuel Antonio", coast: "Central Pacific", count: 218,
  bg: "radial-gradient(ellipse 45% 55% at 40% 55%, #6b9b50 0%, transparent 60%), linear-gradient(180deg, #80c8e2 0%, #c8e0a8 70%, #d3b27a 100%)",
  pins: [{ x: 32, y: 54, c: "#e23838" }, { x: 48, y: 48, c: "#f59e0b" }, { x: 60, y: 62, c: "#38bdf8" }, { x: 42, y: 38, c: "#16a34a" }] },
{ id: "jaco", name: "Jacó & Hermosa", coast: "Central Pacific", count: 174,
  bg: "radial-gradient(ellipse 40% 60% at 65% 50%, #7da55a 0%, transparent 60%), linear-gradient(180deg, #92cde0 0%, #d6cf94 100%)",
  pins: [{ x: 28, y: 52, c: "#38bdf8" }, { x: 46, y: 46, c: "#f59e0b" }, { x: 62, y: 58, c: "#e23838" }] },
{ id: "puerto-viejo", name: "Puerto Viejo", coast: "Caribbean Coast", count: 128,
  bg: "radial-gradient(ellipse 50% 60% at 30% 60%, #4a8654 0%, transparent 60%), linear-gradient(180deg, #98d6b8 0%, #c0d68e 60%, #b88e54 100%)",
  pins: [{ x: 34, y: 54, c: "#16a34a" }, { x: 48, y: 42, c: "#e23838" }, { x: 64, y: 60, c: "#f59e0b" }] }];


// Back from a place ficha that rebuilt the page (no back/forward cache): the
// map the visitor left from. hotspots.js leaves it on the history entry and
// src/main.js reopens it; this keeps the map list marking the same one.
function returnMapCode(choices) {
  try {
    const navigation = performance.getEntriesByType('navigation')[0];
    const code = navigation && navigation.type === 'back_forward' && history.state && history.state.crmapsReturnMap;
    return code && choices.some((item) => item.code === code) ? code : null;
  } catch (err) {
    return null;
  }
}

function RegionsSection({ copy }) {
  const MAP_CHOICES = copy.regions.mapChoices;
  const categoryLabels = copy.categories.labels;
  const [activeCode, setActiveCode] = React.useState(() => returnMapCode(MAP_CHOICES) || MAP_CHOICES[0].code);
  const embedRef = React.useRef(null);
  const listRef = React.useRef(null);

  const sendMap = (code) => {
    setActiveCode(code);
    window.dispatchEvent(new CustomEvent('crmaps:switch-map', { detail: { mapCode: code } }));
  };

  React.useEffect(() => {
    const embed = embedRef.current;
    const list = listRef.current;
    if (!embed || !list) return;

    const updateHeight = () => {
      const rect = embed.getBoundingClientRect();
      if (rect.height > 0) {
        list.style.height = `${rect.height}px`;
      }
    };

    updateHeight();
    let observer = null;
    if (typeof window.ResizeObserver !== "undefined") {
      observer = new ResizeObserver(updateHeight);
      observer.observe(embed);
    }
    window.addEventListener("resize", updateHeight);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <section className="section section--blue-grad" id="regions" data-screen-label="03 Regional Maps">
      <div className="section-inner">
        <div className="reveal">
          <span className="kicker kicker--white">{copy.regions.kicker}</span>
          <h2 className="title">{copy.regions.titlePrefix} <em>{copy.regions.titleEm}</em></h2>
          <p className="lede">{copy.regions.lede}</p>
          <div className="regions-slothy-mobile">
            <p>{copy.regions.slothyHint}</p>
            <div className="regions-slothy-peek">
              <img src="/imagenes/index/slothy_3D_2.png" alt="" />
            </div>
          </div>
        </div>

        <div className="chapter-visor reveal">
          <div className="visor-dropdown" aria-hidden="true">
            <label className="visor-dropdown__control">
              <select
                className="visor-dropdown__select"
                value={activeCode}
                onChange={(event) => sendMap(event.target.value)}
                aria-label={copy.regions.selectLabel}
              >
                {MAP_CHOICES.map((item) => (
                  <option key={item.code} value={item.code}>{item.title}</option>
                ))}
              </select>
              <svg className="visor-dropdown__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </label>
          </div>
          <div className="visor-embed" ref={embedRef}>
            <div className="visor-osd" data-visor-embed="1">
              <select id="map-dzi-select" style={{ display: "none" }} aria-hidden="true" />
              <p id="map-status" className="map-status" style={{ display: "none" }} />
              <div id="viewer-container">
                <div id="map-viewer" aria-label="Interactive deep zoom Map" />
                <div id="map-message" className="map-message" aria-live="polite" />
                <button id="osd-map-button" className="osd-map-button" type="button" aria-label="Select Map">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 22s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="12" cy="10" r="2.5" fill="none" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </button>
                <button id="osd-filter-button" className="osd-filter-button" type="button" aria-label="Filters">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 6h16M7 12h10M10 18h4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <button id="osd-fullscreen-button" className="osd-fullscreen-button" type="button" aria-label="Fullscreen">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <div id="osd-map-panel" className="osd-map-panel" aria-hidden="true">
                  <div className="osd-map-list">
                    {MAP_CHOICES.map((item) => (
                      <button
                        key={`map-${item.code}`}
                        className="osd-map-item"
                        type="button"
                        data-map-code={item.code}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                </div>
                <div id="osd-filter-panel" className="osd-filter-panel" aria-hidden="true">
                  <div className="osd-filter-list">
                    <button className="osd-filter-chip is-on" type="button" data-category="all">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/general_icon.png" alt="" aria-hidden="true" />
                      {copy.regions.allCategories}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="accom">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/accomodation_icom.png" alt="" aria-hidden="true" />
                      {categoryLabels.accommodation}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="rest">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/restaurante_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.restaurant}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="tour">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/transport_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.transport}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="shop">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/shopping_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.shopping}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="default">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/general_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.general}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-beach">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/beach_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.beach}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-park">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/park_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.park}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-atm">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/atm_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.atm}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-info">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/info_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.info}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-hospital">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/hospital_icom.png" alt="" aria-hidden="true" />
                      {categoryLabels.hospital}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-police">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/police_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.police}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-museum">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/museum_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.museum}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-monument">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/monument_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.monument}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-church">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/church_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.church}
                    </button>
                    <button className="osd-filter-chip" type="button" data-category="poi-promo">
                      <img className="osd-filter-chip__icon" src="/imagenes/icons/promo_icon.png" alt="" aria-hidden="true" />
                      {categoryLabels.promo}
                    </button>
                  </div>
                </div>
                <div className="visor-esc-hint" id="visor-esc-hint" aria-hidden="true">{copy.regions.escHint}</div>
              </div>
            </div>
            <div id="visor-slothy-peek" className="visor-slothy-peek" aria-hidden="true">
              <img src="/imagenes/index/slothy_3D.png" alt="" />
            </div>
          </div>
          <div className="visor-list" ref={listRef}>
            {MAP_CHOICES.map((item, idx) => (
              <button
                key={item.code}
                type="button"
                className={`visor-btn ${activeCode === item.code ? "is-active" : ""}`}
                onClick={() => sendMap(item.code)}>
                <span className="visor-btn__num">{String(idx + 1).padStart(2, "0")}</span>
                <span className="visor-btn__text">
                  <strong>{item.title}</strong>
                  {item.subtitle && <span>{item.subtitle}</span>}
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="regions-actions reveal" aria-hidden="true">
          <img src="/imagenes/index/actions.webp" alt="" />
        </div>
        <div className="visor-overlay" id="visor-overlay" aria-hidden="true" />
      </div>
    </section>);

}

window.FloatNav = FloatNav;
window.Hero = Hero;
window.WhatSection = WhatSection;
window.RegionsSection = RegionsSection;
})();
